import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import documentService from '../../services/documentService';
import DocumentForm from '../../components/Documents/DocumentForm';
import Toast from '../../components/Common/Toast';
import FormLoadingSpinner from '../../components/Common/FormLoadingSpinner';

const EditDocument = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    loadDocument();
  }, [id]);

  const loadDocument = async () => {
    try {
      setLoading(true);
      const response = await documentService.getDocument(id);
      
      if (response.success && response.data) {
        setDocument(response.data);
      } else {
        setToast({
          isOpen: true,
          message: 'No se pudo cargar el documento',
          type: 'error'
        });
        setTimeout(() => {
          navigate('/documents');
        }, 2000);
      }
    } catch (error) {
      console.error('Error al cargar documento:', error);
      setToast({
        isOpen: true,
        message: 'Error al cargar el documento',
        type: 'error'
      });
      setTimeout(() => {
        navigate('/documents');
      }, 2000);
    } finally {
      setLoading(false);
    }
  };

  const handleSuccess = (updatedDocument) => {
    setToast({
      isOpen: true,
      message: 'Documento actualizado exitosamente',
      type: 'success'
    });
    setTimeout(() => {
      navigate('/documents');
    }, 1500);
  };

  if (loading) {
    return (
      <div className="p-6">
        <div className="max-w-5xl mx-auto bg-white rounded-xl shadow-sm border border-gray-100">
          <FormLoadingSpinner hint="Obteniendo la información del documento" />
        </div>
      </div>
    );
  }

  if (!document) {
    return null;
  }

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Editar Documento</h1>
          <p className="text-gray-600 mt-1">Modifique la información del documento</p>
        </div>

        {/* Formulario */}
        <DocumentForm
          isOpen={true}
          onClose={() => navigate('/documents')}
          document={document}
          onSuccess={handleSuccess}
          isPageMode={true}
        />

        {/* Toast de notificaciones */}
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default EditDocument;

